var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:'btn btn-'+_vm.buttonClass+'',attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:_vm.iconClass}),_c('span',[_vm._v(_vm._s(_vm.providerLabel))])])}
var staticRenderFns = []

export { render, staticRenderFns }